module.exports = __webpack_public_path__ + "static/media/bettr-create-profile.340a639e.png";